import { parseAsArrayOf, parseAsString, useQueryStates } from 'nuqs'

// Define all filter parsers - align with useInvoiceQuery expected parameters
const companyFilterParsers = {
  // Search query
  search: parseAsString.withDefault('').withOptions({
    clearOnDefault: true,
  }),

  // Status filters
  type: parseAsArrayOf(parseAsString, ',').withDefault(['all']).withOptions({
    clearOnDefault: true,
  }),
}

export function useCompanyFilters() {
  const [filters, setFilters] = useQueryStates(companyFilterParsers, {
    history: 'replace', // Use replace to avoid cluttering browser history
    shallow: true, // Client-side only updates
  })

  // Helper functions for easier state management
  const updateSearch = (search: string) => {
    setFilters((prev) => ({ ...prev, search }))
  }

  const updateType = (statuses: string[]) => {
    setFilters((prev) => ({ ...prev, type: statuses }))
  }

  const clearAllFilters = () => {
    // Clear all filters in a single atomic operation to prevent step-by-step clearing
    setFilters({
      search: '',
      type: ['all'],
    })
  }

  // Check if any filters are active (excluding defaults)
  const hasActiveFilters =
    filters.search !== '' || !filters.type.includes('all')

  return {
    // Current filter values
    filters,

    // Update functions
    updateSearch,
    updateType,
    setFilters,
    clearAllFilters,

    // Helper states
    hasActiveFilters,
  }
}

// Type exports for better TypeScript support
export type CompanyFilters = ReturnType<typeof useCompanyFilters>['filters']
export type CompanyFilterKey = keyof typeof companyFilterParsers
